/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeUnexpectedPaymentOutcomePostRequestSchema } from './changeUnexpectedPaymentOutcomePostRequestSchema.ts';
import { changeUnexpectedPaymentOutcomePostResponseSchema } from './changeUnexpectedPaymentOutcomePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangeUnexpectedPaymentOutcome200Schema = z.lazy(
  () => changeUnexpectedPaymentOutcomePostResponseSchema
);

/**
 * @description 505 response
 */
export const postChangeUnexpectedPaymentOutcome505Schema = z.any();

export const postChangeUnexpectedPaymentOutcomeMutationRequestSchema = z.lazy(
  () => changeUnexpectedPaymentOutcomePostRequestSchema
);

export const postChangeUnexpectedPaymentOutcomeMutationResponseSchema = z.lazy(
  () => postChangeUnexpectedPaymentOutcome200Schema
);
